// SETUP COLORS

export const grey = {
    0: '#212B36',
    100: '#454F5B',
    200: '#637381',
    300: '#919EAB',
    400: '#C4CDD5',
    500: '#DFE3E8',
    600: '#F4F6F8',
    700: '#F9FAFB',
    800: '#FFFFFF',
    900: '#FFFFFF',
};

export const primary = {
    lighter: '#042174',
    light: '#0C44AE',
    main: '#1877F2',
    dark: '#0C44AE',
    darker: '#042174',
    contrastText: '#FFFFFF',
};

export const secondary = {
    lighter: '#27097A',
    light: '#5119B7',
    main: '#8E33FF',
    dark: '#5119B7',
    darker: '#27097A',
    contrastText: '#FFFFFF',
};

export const info = {
    lighter: '#003768',
    light: '#006C9C',
    main: '#00B8D9',
    dark: '#006C9C',
    darker: '#003768',
    contrastText: '#FFFFFF',
};

export const success = {
    lighter: '#004B50',
    light: '#007867',
    main: '#00A76F',
    dark: '#007867',
    darker: '#004B50',
    contrastText: '#FFFFFF',
};

export const warning = {
    lighter: '#7A4100',
    light: '#B76E00',
    main: '#FFAB00',
    dark: '#B76E00',
    darker: '#7A4100',
    contrastText: grey[800],
};

export const error = {
    lighter: '#7A0916',
    light: '#B71D18',
    main: '#FF5630',
    dark: '#B71D18',
    darker: '#7A0916',
    contrastText: '#FFFFFF',
};

export const common = {
    black: '#FFFFFF',
    white: '#000000',
};

export const action = {
    hover: 'rgba(255, 255, 255, 0.08)',
    selected: 'rgba(255, 255, 255, 0.16)',
    disabled: 'rgba(255, 255, 255, 0.8)',
    disabledBackground: 'rgba(255, 255, 255, 0.24)',
    focus: 'rgba(255, 255, 255, 0.24)',
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
};

const darkThemeBase = {
    primary,
    secondary,
    info,
    success,
    warning,
    error,
    grey,
    common,
    divider: 'rgba(255, 255, 255, 0.2)',
    action,
};

export default darkThemeBase;
